(function(){
  var idle = window.requestIdleCallback || function(cb){return setTimeout(cb,150);};
  function loadScript(src, attrs){
    var s=document.createElement('script'); s.src=src; s.defer=true;
    if(attrs){ for (var k in attrs){ s.setAttribute(k, attrs[k]); } }
    document.body.appendChild(s);
  }
  idle(function(){
    document.querySelectorAll('script[data-noncritical][data-src]').forEach(function(el){
      loadScript(el.getAttribute('data-src'));
    });
  });
  idle(function(){
    document.querySelectorAll('script[data-foxkit][data-src]').forEach(function(el){
      loadScript(el.getAttribute('data-src'), {"data-foxkit":"true"});
    });
  });
})();